import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { MDBModalRef,MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeAulaVirtualService } from 'src/app/service/mae-aulavirtual.service';
import { MaeConstanciaService } from 'src/app/service/mae-constancia.service';
import { DetFirmanteService } from 'src/app/service/det-firmante.service';
import { MaePlantillaService } from 'src/app/service/mae-plantilla.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';

import { MaePlantillaM} from 'src/app/model/mae-plantilla-bean'
import { DetFirmanteM} from 'src/app/model/det-firmante-bean'
import { MaeConstanciaE,MaeConstanciaM } from 'src/app/model/mae-constancia-bean';
import { MaeAVCursosM } from 'src/app/model/mae-aulavirtual-bean'
import { EliminarDml } from 'src/app/model/estadoDml';

import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { RequestCredencialesConvenio,RequestCredencialesExterno } from 'src/app/model/request_credenciales';
import { AuditoriaBeanM } from 'src/app/model/auditoria_bean';
import { MatDialog } from "@angular/material/dialog";
import { AddFirmanteComponent } from 'src/app/pagina-admin/dashboard/gestion-constancia/dml-constancia/add-firmante/add-firmante.component';
import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';
import { ConfirmarComponent } from 'src/app/comunes/confirmar/confirmar.component';

@Component({
  selector: 'app-dml-constancia',
  templateUrl: './dml-constancia.component.html',
  styleUrls: ['./dml-constancia.component.scss']
})

export class DmlConstanciaComponent implements OnInit {

  //action del padre para el retorno de datos
  action: Subject<Response_dml_bean> = new Subject();
  //variables enviado desde el padre
  id:String;
  x_titulo:String;
  x_proceso:String;
  x_estado:String;
  c_tipo:String;

  fecha_constancia:String;

  //habilitar
  id_categoria:number=0;
  cursohabilitado:boolean=false;

  //documento
  maeConstanciaE = new MaeConstanciaE();
  listPlantillas = new Array<MaePlantillaM>();
  listFirmantesM = new Array<DetFirmanteM>();
  listCursos = new Array<MaeAVCursosM>();
  idCurso:Number;
  listCategorias = new Array<MaeAVCursosM>();
  listEstado= new Array<Mae_tabla_E>();

  c_plantilla:number;
  eliminadoDml = new EliminarDml();
  //modal
  modalRefFirmanteDml: MDBModalRef;
  //archivo
  x_file:File=null;
  @ViewChild('labelArchivo')
  labelArchivo: ElementRef;

  esCursoAV:boolean= true;
  seactualiza:boolean=false;
  esupdate:boolean;

  seguardo:boolean=false;

  constructor(
    public  modalRefConstanciaDml: MDBModalRef,
    private modalService: MDBModalService,
    private maeAulaVirtual:MaeAulaVirtualService,
    private maeTablaService:MaeTablaService,
    private detFirmanteService:DetFirmanteService,
    private globalVariablesService:GlobalVariablesService,
    private detArchivoService:DetArchivoService,
    private maePlantillaService:MaePlantillaService,
    private utilitarioService:UtilitarioService,
    private maeConstanciaService:MaeConstanciaService,
    private dialogo: MatDialog,
  ) { }

  ngOnInit(): void {

    this.cargarDatoInicial(this.x_proceso);
  }
  cargarDatoInicial(dml:String){

    this.utilitarioService.loading = true;

    if (dml=='I'){
      const cargarCategorias = this.maeAulaVirtual.getCategorias(this.c_tipo.toString()).toPromise()
      .then(result => {
        this.listCategorias = result;
      });

      var nombres = "*";
      var estado = "3";    // estado activo
      const cargarPlantillas = this.maePlantillaService.getfind(nombres,estado).toPromise()
      .then(result => {
        this.listPlantillas = result;
      });

      this.c_plantilla=0;
      this.idCurso = 0;
      this.maeConstanciaE.c_curso=0;
      this.maeConstanciaE.c_estado = 31;
      this.maeConstanciaE.c_tipo = this.c_tipo;
      var datePipe = new DatePipe("en-US");
      var hoy = new Date();
      this.fecha_constancia = datePipe.transform(hoy, 'yyyy-MM-dd');

      //carga los promesas culminadas para asignar los datos a las variables
      Promise.all([cargarCategorias,cargarPlantillas])
      .then(response => {
        this.utilitarioService.loading = false;
      })
      .catch(error => console.log(`Error in executing ${error}`));
    }

    if(dml=='U'){
      const cargarFirmantes = this.detFirmanteService.get(this.id.toString()).toPromise()
      .then(result => {
        this.listFirmantesM = result;
      });

      let cargarMaeConstancia = this.maeConstanciaService.get(this.id.toString()).toPromise()
      .then(result => {
        this.maeConstanciaE = result[0];
        if(this.maeConstanciaE.c_curso==0)
        {
          this.esCursoAV = false;
        }

        this.idCurso = this.maeConstanciaE.c_curso;
       // this.c_plantilla = this.maeConstanciaE.c_pla
        this.fecha_constancia = this.maeConstanciaE.f_constancia;
        console.log(this.maeConstanciaE);
      });
      Promise.all([cargarMaeConstancia,cargarFirmantes])
      .then(response => {
        this.utilitarioService.loading = false;
      });
    }
  }

  onCategoriaChange()
  {

    var id_cat = this.id_categoria.toString();

    if(id_cat === "0")
    {
      this.cursohabilitado = false;
      this.idCurso = 0;
    }


    else
    {
      const cargarCursos = this.maeAulaVirtual.getCursos(id_cat,this.c_tipo.toString()).toPromise()
      .then(result => {
        this.listCursos = result;
        this.idCurso = this.listCursos[0].id;
        this.maeConstanciaE.x_curso  = this.listCursos[0].nombre;
      });
      Promise.all([cargarCursos])
      .then(response => {
        this.cursohabilitado = true;
      })
      .catch(error => console.log(`Error in executing ${error}`));
    }
  }
  onPlantillaChange()
  {
    var id_plant = this.c_plantilla;
    if(id_plant>0)
    {
      var resul = this.listPlantillas.filter(val => val.c_plantilla == id_plant);
      if(resul.length>0)
        this.maeConstanciaE.x_uid = resul[0].x_uid;
      //console.log(this.maeConstanciaE.x_uid);
    }
    else
      this.maeConstanciaE.x_uid = '';
  }
  onCursoChange()
  {
    var id_curso = this.idCurso;
    var resul = this.listCursos.filter(val => val.id == id_curso);
    if(resul.length>0)
        this.maeConstanciaE.x_curso = resul[0].nombre;
  }
  onFileChange(files: FileList){

    this.labelArchivo.nativeElement.innerText = Array.from(files)
      .map(f => f.name)
      .join(', ');

    this.x_file = files.item(0);
    console.log(files.item(0));

  }
  onMostrarActualizar(semuestr:boolean){

    if(semuestr)
    {
      this.seactualiza=true;
    }
    else
    {
      this.seactualiza=false;
      this.x_file = null;
    }
  }


  onGrabar(){


    if (this.validarFormulario()==false){
      return false;
    }
    this.utilitarioService.loading=true;
    this.maeConstanciaE.f_constancia=this.dateFormat(this.fecha_constancia,"1");

    let auditoriaBeanM = new AuditoriaBeanM();
    auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio(this.x_proceso);
    this.maeConstanciaE.auditoriaBeanM = auditoriaBeanM;

    console.log(this.maeConstanciaE);

    if(this.x_proceso=='I')
      this.maeConstanciaService.insert(this.maeConstanciaE).subscribe((response_dml_bean:Response_dml_bean)=>{

        this.utilitarioService.loading=false;
        if (response_dml_bean.codigoRespuestaServicio=="1"){
          this.action.next(response_dml_bean);
          this.onClosemodal();
        }
      },
      error=>{
        this.utilitarioService.loading=false;
        console.log(error);
        this.utilitarioService.toastrError(error.error.messages.toString());
      });
      else // update
      this.maeConstanciaService.update(this.maeConstanciaE).subscribe((response_dml_bean:Response_dml_bean)=>{

        this.utilitarioService.loading=false;
        if (response_dml_bean.codigoRespuestaServicio=="1"){
          this.action.next(response_dml_bean);
          this.onClosemodal();
        }
      },
      error=>{
        this.utilitarioService.loading=false;
        console.log("error en servicio");
        this.utilitarioService.toastrError(error.error.messages.toString());
      });
  }

  validarFormulario() : Boolean{



    if (this.maeConstanciaE.x_titulo==null || this.maeConstanciaE.x_titulo.length==0){
      this.utilitarioService.toastrError("Ingrese un formato para la constancia.");
      return false;
    }

    if(this.esCursoAV)
      if (this.idCurso==0){
        this.utilitarioService.toastrError("Seleccione un curso para la constancia.");
        return false;
      }
      else
        this.maeConstanciaE.c_curso = this.idCurso;
    else
      this.maeConstanciaE.c_curso==0;

    if (this.maeConstanciaE.x_curso=="" || this.maeConstanciaE.x_curso==null){
      this.utilitarioService.toastrError("Ingrese un curso para la constancia.");
      return false;
    }

    if (this.maeConstanciaE.x_uid=="" || this.maeConstanciaE.x_uid==null){
      this.utilitarioService.toastrError("Seleccione una plantilla.");
      return false;
    }

    return true;
  }

  onActualizarPlantilla(){

    if (this.x_file==null){
      this.utilitarioService.toastrError("Seleccione un archivo.");
      return false;
    }
    if (this.x_file.size<=0){
      this.utilitarioService.toastrError("Seleccione un archivo.");
      return false;
    }

    this.utilitarioService.loading=true;
    // se sube el archivo con actualizacion del archivo
    let formData = new FormData;

    formData.append("file",this.x_file);
    this.detArchivoService.uploadPlantilla(formData,this.id.toString(),'0').subscribe( (response_dml_bean : Response_dml_bean) => {

      this.utilitarioService.loading=false;
      if (response_dml_bean.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(response_dml_bean.mensaje);
        this.maeConstanciaE.x_uid = response_dml_bean.codigoRegistroBD;
        this.onMostrarActualizar(false);
      }
      else
        this.utilitarioService.toastrError(response_dml_bean.mensaje);
      console.log(response_dml_bean);
    },
    error=>{
      this.utilitarioService.toastrError("Hubo un error al guardar el archivo." + error.error.messages.toString());
      this.utilitarioService.loading=false;
    });
  }

  onAgregarFirmante()
  {
    var nrofirmantes = this.listFirmantesM.length;
    if(nrofirmantes<2)
    {
      var iduserexiste = 0 as Number;
      if(nrofirmantes>0)
        iduserexiste = this.listFirmantesM[0].c_usuario;

      this.modalRefFirmanteDml = this.modalService.show(AddFirmanteComponent,
        {
          backdrop: true,
          keyboard: true,
          focus: true,
          show: false,
          ignoreBackdropClick: false,
          class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
          containerClass: 'top',
          animated: true,
          data: {
            x_titulo:'Nuevo Firmante',
            id_constancia:this.id,
            n_secuencia:this.listFirmantesM.length+1,
            id_usuario_existe: iduserexiste
          }
        }
      );

      this.modalRefFirmanteDml.content.action.subscribe( (result: Response_dml_bean) =>
      {
        if (result.codigoRespuestaServicio=="1"){
          this.utilitarioService.toastrSuccess(result.mensaje);
           this.utilitarioService.loading = true;
            this.detFirmanteService.get(this.id.toString()).subscribe(data=>{
            this.listFirmantesM = data;
            this.utilitarioService.loading = false;
          });
        }else{
          this.utilitarioService.toastrError(result.mensaje);
        }

      });
    }
   else
    this.utilitarioService.toastrInfo("No se puede agregar mas de dos firmantes.");
  }

  onDeleteFirmante(detFirmanteM:DetFirmanteM){
    /* const index = this.listDetOrganoAsignadoM.indexOf(fila);
    this.listDetOrganoAsignadoM.splice(index, 1); */
    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: '¿Desea eliminar el firmante seleccionado?.'},
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {

      if (confirmado) {

        let auditoriaBeanM = new AuditoriaBeanM();
          auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio("D");
          this.eliminadoDml.auditoriaBeanM =auditoriaBeanM;
          this.eliminadoDml.x_tabla = "DET_FIRMANTE"; //en proceso de evaluacion
          this.eliminadoDml.c_id = String(detFirmanteM.c_firmante);
          this.eliminadoDml.b_eliminado = "1";

          this.utilitarioService.loading = true;

        console.log(this.eliminadoDml);
        this.maeTablaService.deleteDML(this.eliminadoDml).subscribe(result=>{
          if (result.codigoRespuestaServicio=="1"){
            this.utilitarioService.toastrSuccess(result.mensaje);
             this.detFirmanteService.get(this.id.toString()).subscribe(data=>{
            this.listFirmantesM = data;
            });
          }else{
            this.utilitarioService.toastrWarning(result.mensaje);
          };

          this.utilitarioService.loading = false;
        });

      } else {
        return;
      }
    });
  }


  onDescargarArchivo(){
    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(this.maeConstanciaE.x_uid.toString()).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,this.maeConstanciaE.x_prefijo_nro + '.docx');
    });
  }
  dateFormat(cadena:String, tipo:String) {

    if (tipo=="1"){

      var arrayDeCadenas = cadena.split("-");
      console.log(arrayDeCadenas);
      if (arrayDeCadenas.length>1){
        return  arrayDeCadenas[2] + '/' + arrayDeCadenas[1] + '/' + arrayDeCadenas[0];
      }else{
        return cadena;
      }

    }else{

      var arrayDeCadenas = cadena.split("/");
      console.log(arrayDeCadenas);
      if (arrayDeCadenas.length>1){
        return  arrayDeCadenas[2] + '-' + arrayDeCadenas[1] + '-' + arrayDeCadenas[0];
      }else{
        return cadena;
      }

    }

  }
  onInformacionPrefijo()
  {
    this.dialogo.open(ConfirmarComponent, {
      data: { mensaje: 'El prefijo es la parte inicial del numero de constancia que se generará para cada participante. Por ejemplo si registra CA-GPS-2023 como prefijo, en numero de constancias para el primer participante sera CA-GPS-20230001.',
    mensaje_negrita:''},
      width: '550px'
    });
  }
  onCursoOrigen(){
    if(!this.esCursoAV)
    {
      this.id_categoria = 0;
      this.onCategoriaChange();
    }
  }
  onClosemodal(){
    this.modalRefConstanciaDml.hide();
  }
}
